
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/career-guides/[slug]",
      function () {
        return require("private-next-pages/career-guides/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/career-guides/[slug]"])
      });
    }
  